import React from "react";

export default function ApplyRemoveLabelsIcon() {
  return (
    <svg
      id="Icon_-_Apply_or_Remove_Labels"
      data-name="Icon - Apply or Remove Labels"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
    >
      <path
        id="Union_14"
        data-name="Union 14"
        d="M0,8A8,8,0,0,1,15.5,5.228,5.5,5.5,0,0,0,13.932,5a5.633,5.633,0,0,0-.711.045A6,6,0,1,0,9.532,13.8a5.567,5.567,0,0,0,1.724,1.5A7.918,7.918,0,0,1,8,16,8.009,8.009,0,0,1,0,8Zm14.787,5.922-.3-.522a3.262,3.262,0,0,1-1.159,0l-.3.522a.451.451,0,0,1-.552.2,4.05,4.05,0,0,1-1.174-.68.454.454,0,0,1-.1-.573l.3-.523a3.16,3.16,0,0,1-.581-1h-.6a.45.45,0,0,1-.446-.376,4.084,4.084,0,0,1,0-1.356.454.454,0,0,1,.446-.38h.6a3.144,3.144,0,0,1,.581-1l-.3-.523a.451.451,0,0,1,.1-.574,4.092,4.092,0,0,1,1.174-.679.452.452,0,0,1,.552.2l.3.523a3.256,3.256,0,0,1,1.159,0l.3-.523a.451.451,0,0,1,.552-.2,4.04,4.04,0,0,1,1.173.679.454.454,0,0,1,.1.574l-.3.523a3.161,3.161,0,0,1,.581,1h.6a.451.451,0,0,1,.446.376,4.133,4.133,0,0,1,0,1.356.453.453,0,0,1-.446.38h-.6a3.177,3.177,0,0,1-.581,1l.3.523a.448.448,0,0,1-.1.573,4.094,4.094,0,0,1-1.173.68.468.468,0,0,1-.161.029A.445.445,0,0,1,14.787,13.922Zm-1.842-2.675a1.365,1.365,0,0,0,1.93-1.93,1.581,1.581,0,0,0-.966-.355A1.355,1.355,0,0,0,12.944,11.247Z"
        fill="currentColor"
      />
    </svg>
  );
}
